<button class="btn btn-{{size}} btn-{{type}}" type="button">
        {{text | word}}
</button>